import OverlayOrderbox from '@/pages/OverlayOrderbox'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		...opts,
		vueComponent: OverlayOrderbox,
		// vueInit: "initializeOrderbox",
	}

	let page = vuewidget(dom, options)
	return page
}
